export default __webpack_public_path__ + "static/media/Btis-partner1.c7650e36.png";